module.exports = __webpack_public_path__ + "img/103.9.39c47d41.png";